<template>
  <div>
    <beast-header/>
    <div class="container">
      <div class="row">
        <div class="col-12 beast-category-display">
          <h1 class="beast-category-title">{{category.name}}</h1>
          <div class="beast-category-content">
            <h4 class="beast-category-page"
                v-for="page in pages.data"
                :key="page.slug">
              <router-link :to="`/dms/pages/${page.slug}`">
                {{page.title}}
              </router-link>
            </h4>

            <pagination :current="pages.page"
                        :pages="pages.pages"
                        @pageChange="readData"/>
          </div>
        </div>
      </div>
    </div>
    <beast-footer/>
  </div>
</template>

<style scoped lang="scss">
  .beast-category-display {
    .beast-category-title {

    }

    .beast-category-content {
      margin-top: 20px;

      .beast-category-page {
        margin-bottom: 20px;
        padding-left: 15px;

        a {
          color: $beast-gray;

          &:before {
            content: "\2022";
            color: $beast-green;
          }
        }
      }
    }
  }
</style>

<script>
import BeastHeader from "../components/header/BeastHeader.vue";
import BeastFooter from "../components/footer/BeastFooter.vue";
import Pagination from "../components/utils/Pagination.vue";

export default {
  components: {
    Pagination,
    BeastFooter,
    BeastHeader
  },
  props: {
    slug: {
      type: String,
    }
  },
  watch: {
    slug() {
      this._fetchData();
    }
  },
  data() {
    return {
      pages: {
        data: [],
        count: 0,
        page: 0,
        pages: 0,
        size: 0
      },
      category: {
        name: "",
        slug: ""
      }
    };
  },
  methods: {
    async _fetchData() {
      const response = await this.axios.get(`/dms/category/${this.slug}`);
      this.category = response.data;
      this.setTitle(`Category: ${this.category.name}`);
      this.readData();
    },

    async readData(page = 1) {
      const queryParams = {
        params: {
          size: 20,
          page
        }
      };

      const response = await this.axios.get(`/dms/category/${this.slug}/pages`, queryParams);
      this.pages = response.data;
    }
  },
  beforeMount() {
    this._fetchData();
  }
};
</script>
